import { render, staticRenderFns } from "./CellRendererCategory.vue?vue&type=template&id=132e0568"
import script from "./CellRendererCategory.vue?vue&type=script&lang=js"
export * from "./CellRendererCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports